/*============================================================================
  Animated Icons
==============================================================================*/
var lottieScript = document.createElement('script');
lottieScript.onload = InitAnimatedIcons;
lottieScript.src = universe.lottieLink;
document.head.appendChild(lottieScript);         

function InitAnimatedIcons() {    
    var asset_url = universe.assetsUrl;
    var asset_url_index = asset_url.indexOf('universe.js');
    var baseAssetUrl = asset_url.slice(0, asset_url_index);

    document.querySelectorAll('.animated-icon').forEach(el => {
        var animationEl = el;        
        var iconName = animationEl.getAttribute('data-icon');

        if (!animationEl.classList.contains('__enabled')) {
            var animation = bodymovin.loadAnimation({
                container: animationEl,
                renderer: 'svg',
                loop: true,
                autoplay: true,
                path: baseAssetUrl + iconName + '.json'
            });
        }
        animationEl.classList.add('__enabled');
    });
}
    
